import secondImg from "./secondImg.jpg";
import "./styles.css";

export default function SecondImage() {
    return (
        <img src={secondImg} alt="Foto de Andres y Mafer" className="second-image"/>
    );
};